module.exports = __webpack_public_path__ + "img/docker.9ee37e02.png";